import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useSelector} from 'react-redux';

import {getCountryByLanguage} from 'front-onceforall-core/dist/utils/country';

import {ENTITY_BY_COUNTRY} from '../../utils/constant';

import ContactForm from './ContactForm';

function Contact(props) {
  const [user, organisation] = useSelector(state => ([
    state.user,
    state.organisation
  ]));

  const country = organisation?.country || getCountryByLanguage(user.language);

  return (
    <div
      className="inline-container column"
      style={{width: '100%'}}
    >
      {organisation &&
        <ContactForm
          organisationId={organisation.organisationId}
          onClose={props.onClose}
          selectedRequestType={props.selectedRequestType}
        />
      }
      <div
        data-id="contact-information"
        style={{textAlign: 'center'}}
      >
        <p><Translate value={`contact.phone.${ENTITY_BY_COUNTRY[country]}`}/></p>
        <p><Translate value={`contact.horary.${ENTITY_BY_COUNTRY[country]}`}/></p>
      </div>
    </div>
  );
}

Contact.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedRequestType: PropTypes.string
};

export default Contact;
